/** Parse a JSON object out of a model's text reply, tolerating markdown fences and prose
 *  around the object. Shared by extraction (lib/ai.js) and the AI box, which must not
 *  import the Firebase callable. */
export function parseClaudeJSON(text) {
  const cleaned = String(text || "").replace(/```json\s*|```/g, "").trim();
  try {
    return JSON.parse(cleaned);
  } catch {
    const match = cleaned.match(/\{[\s\S]*\}/);
    if (!match) throw new Error("No JSON found in AI response");
    return JSON.parse(match[0]);
  }
}
